import { abrePDF } from "../../../utils/pdf";
import React, { useState, useEffect, useContext, useMemo } from "react";
import { fDMA } from "../../../utils/fecha";
import { AuthContext } from "../../../contexts/AuthContext";
import Header from "../../../layout/Header/Header";
import {
  Button,
  Row,
  Table,
  Input,
  Label,
  ButtonGroup,
  Col,
  Badge,
} from "reactstrap";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import ExportJsonExcel from "js-export-excel";
import axios from "axios";
import { TableHeader, Pagination, Search } from "../../../DataTable";
import useFullPageLoader from "../../../hooks/useFullPageLoader";
import moment from "moment";

function ReporteUtilidades() {
  const { user } = useContext(AuthContext);
  const URL_REPORTE_UTILIDADES = process.env.REACT_APP_URL_REPORTE_UTILIDADES;
  const URL_CLIENTES = process.env.REACT_APP_URL_CLIENTES;

  let hoy = new Date();
  let inicio = new Date();
  inicio.setDate(inicio.getDate() - 30);

  let endDate = moment(hoy).format("YYYY-MM-DD");
  let startDate = moment(inicio).format("YYYY-MM-DD");

  const [selectedFechaInicio, setSelectedFechaInicio] = useState(startDate);
  const [selectedFechaFin, setSelectedFechaFin] = useState(endDate);
  const [clientes, setClientes] = useState([]);
  const [selectedCliente, setSelectedCliente] = useState("");

  const [renglones, setRenglones] = useState([]);
  const [totales, setTotales] = useState(null);
  const [infoGastos, setInfoGastos] = useState(null);
  const [cargando, setCargando] = useState(false);
  const [verAyuda, setVerAyuda] = useState(false);

  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });

  const ITEMS_PER_PAGE = 50;

  const money = (v) =>
    new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      maximumFractionDigits: 2,
    }).format(Number(v) || 0);

  const headers = [
    { name: "Nota", field: "idSurtido", sortable: true },
    { name: "Fecha", field: "fecha", sortable: true },
    { name: "Cliente", field: "cliente", sortable: true },
    { name: "Factura", field: "factura", sortable: true },
    { name: "Venta", field: "venta", sortable: true },
    { name: "Costo", field: "costo", sortable: true },
    { name: "Comisión", field: "comision", sortable: true },
    { name: "Comisión est.", field: "comisionEstimada", sortable: true },
    { name: "Gasto Directo", field: "gastoDirecto", sortable: true },
    { name: "Gasto General", field: "gastoGeneral", sortable: true },
    { name: "Utilidad", field: "utilidad", sortable: true },
    { name: "Margen", field: "margen", sortable: true },
  ];

  useEffect(() => {
    axios
      .get(URL_CLIENTES, {
        headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
      })
      .then((res) => setClientes(res.data || []))
      .catch((err) => console.log(err));
  }, [URL_CLIENTES]);

  useEffect(() => {
    setCargando(true);
    showLoader();
    const query = selectedCliente ? `?cliente=${selectedCliente}` : "";
    axios
      .get(
        `${URL_REPORTE_UTILIDADES}/${selectedFechaInicio}/${selectedFechaFin}${query}`,
        { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } }
      )
      .then((res) => {
        setRenglones(res.data?.renglones || []);
        setTotales(res.data?.totales || null);
        setInfoGastos(res.data?.gastosGenerales || null);
      })
      .catch((err) => {
        console.log("[utilidades]", err);
        setRenglones([]);
        setTotales(null);
      })
      .finally(() => {
        setCargando(false);
        hideLoader();
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedFechaInicio, selectedFechaFin, selectedCliente]);

  const filtrado = useMemo(() => {
    let filas = renglones;

    if (search) {
      const s = search.toLowerCase();
      filas = filas.filter(
        (r) =>
          String(r.cliente || "").toLowerCase().includes(s) ||
          String(r.factura || "").toLowerCase().includes(s) ||
          String(r.idSurtido || "").includes(search)
      );
    }

    if (sorting.field) {
      // Los importes se ordenan como número; lo demás como texto.
      const numericos = [
        "venta", "costo", "comision", "comisionEstimada", "gastoDirecto",
        "gastoGeneral", "utilidad", "margen", "idSurtido",
      ];
      const dir = sorting.order === "desc" ? -1 : 1;
      filas = [...filas].sort((a, b) =>
        numericos.includes(sorting.field)
          ? dir * (Number(a[sorting.field] || 0) - Number(b[sorting.field] || 0))
          : dir * String(a[sorting.field] ?? "").localeCompare(String(b[sorting.field] ?? ""))
      );
    }

    setTotalItems(filas.length);

    return filas.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [renglones, search, sorting, currentPage]);

  // El PDF y el Excel salen con TODO lo filtrado, no sólo la página en pantalla.
  const paraExportar = useMemo(() => {
    let filas = renglones;
    if (search) {
      const s = search.toLowerCase();
      filas = filas.filter(
        (r) =>
          String(r.cliente || "").toLowerCase().includes(s) ||
          String(r.factura || "").toLowerCase().includes(s) ||
          String(r.idSurtido || "").includes(search)
      );
    }
    return filas;
  }, [renglones, search]);

  const sumaDe = (campo) =>
    paraExportar.reduce((t, r) => t + Number(r[campo] || 0), 0);

  function PDFTabla() {
    const doc = new jsPDF("landscape", "mm", "a4", true);
    const img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 240, 12, 35, 15);
    doc.text(`Reporte de Utilidades`, 15, 20);
    doc.text(`${fDMA(selectedFechaInicio)} - ${fDMA(selectedFechaFin)}`, 15, 27);
    if (selectedCliente) {
      const c = clientes.find((x) => x._id === selectedCliente);
      doc.text(`Cliente: ${c?.nombre_comercial || ""}`, 15, 34);
    }

    const ventaTot = sumaDe("venta");
    const utilidadTot = sumaDe("utilidad");

    doc.autoTable({
      head: [
        ["Nota", "Fecha", "Cliente", "Factura", "Venta", "Costo",
         "Comisión", "Com. est.", "G. Directo", "G. General", "Utilidad", "Margen"],
      ],
      body: paraExportar.map((r) => [
        r.idSurtido,
        fDMA(r.fecha),
        r.cliente,
        r.factura,
        money(r.venta),
        money(r.costo),
        money(r.comision),
        money(r.comisionEstimada),
        money(r.gastoDirecto),
        money(r.gastoGeneral),
        money(r.utilidad),
        `${r.margen}%`,
      ]),
      headStyles: { fillColor: ["#B02307"], lineWidth: 0 },
      footStyles: { fillColor: ["#B02307"] },
      theme: "grid",
      startY: selectedCliente ? 40 : 34,
      styles: { fontSize: 7 },
      columnStyles: {
        4: { halign: "right" }, 5: { halign: "right" }, 6: { halign: "right" },
        7: { halign: "right" }, 8: { halign: "right" }, 9: { halign: "right" },
        10: { halign: "right" }, 11: { halign: "right" },
      },
      foot: [
        [
          "", "", "",
          { content: "TOTALES", styles: { halign: "right" } },
          money(ventaTot),
          money(sumaDe("costo")),
          money(sumaDe("comision")),
          money(sumaDe("comisionEstimada")),
          money(sumaDe("gastoDirecto")),
          money(sumaDe("gastoGeneral")),
          money(utilidadTot),
          ventaTot > 0 ? `${((utilidadTot / ventaTot) * 100).toFixed(2)}%` : "0%",
        ],
      ],
      showFoot: "lastPage",
    });

    abrePDF(doc, `ReporteUtilidades.pdf`);
  }

  function excel() {
    const option = {};
    option.fileName = "ReporteUtilidades";
    option.datas = [
      {
        sheetData: paraExportar.map((r) => ({
          Nota: r.idSurtido,
          Fecha: fDMA(r.fecha),
          Cliente: r.cliente,
          Factura: r.factura,
          Venta: r.venta,
          Costo: r.costo,
          Comision: r.comision,
          ComisionEstimada: r.comisionEstimada,
          GastoDirecto: r.gastoDirecto,
          GastoGeneral: r.gastoGeneral,
          Utilidad: r.utilidad,
          Margen: r.margen,
        })),
        sheetName: "ReporteUtilidades",
        sheetFilter: [
          "Nota", "Fecha", "Cliente", "Factura", "Venta", "Costo",
          "Comision", "ComisionEstimada", "GastoDirecto", "GastoGeneral", "Utilidad", "Margen",
        ],
        sheetHeader: [
          "Nota", "Fecha", "Cliente", "Factura", "Venta", "Costo",
          "Comisión", "Comisión est.", "Gasto Directo", "Gasto General", "Utilidad", "Margen %",
        ],
      },
    ];
    new ExportJsonExcel(option).saveExcel();
  }

  const ventaFiltrada = sumaDe("venta");
  const utilidadFiltrada = sumaDe("utilidad");
  const margenFiltrado =
    ventaFiltrada > 0 ? ((utilidadFiltrada / ventaFiltrada) * 100).toFixed(2) : "0.00";

  return (
    <>
      <Header />
      <br />
      <br />
      {/* Mismo permiso que su botón en Ventas: no basta esconder el botón,
          la ruta se puede escribir a mano. */}
      {user.menu_admin ? (
        <div className="card container col-12">
          <Row>
            <Col md={3}>
              <ButtonGroup>
                <Button size="sm" className="btn" color="danger" onClick={PDFTabla}>
                  PDF <i class="far fa-file-pdf"></i>
                </Button>
                <Button size="sm" className="btn" color="primary" onClick={excel}>
                  Excel <i class="far fa-file-excel"></i>
                </Button>
              </ButtonGroup>
            </Col>
            <Col sm={9}>
              <ButtonGroup id="logoutBoton">
                <Button href="/MenuVentas" className="btn btn-danger" id="botonListado">
                  Regresar
                </Button>
              </ButtonGroup>
            </Col>
          </Row>

          <h3 align="center">Reporte de Utilidades</h3>

          <Row className="mb-2">
            <Col md={2}>
              <Label className="mr-sm-2">Fecha Inicio</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaInicio}
                onChange={(e) => {
                  setSelectedFechaInicio(e.target.value);
                  setCurrentPage(1);
                }}
              />
            </Col>
            <Col md={2}>
              <Label className="mr-sm-2">Fecha Fin</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaFin}
                onChange={(e) => {
                  setSelectedFechaFin(e.target.value);
                  setCurrentPage(1);
                }}
              />
            </Col>
            <Col md={3}>
              <Label className="mr-sm-2">Cliente</Label>
              <Input
                bsSize="sm"
                type="select"
                value={selectedCliente}
                onChange={(e) => {
                  setSelectedCliente(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="">Todos</option>
                {clientes
                  .sort((a, b) =>
                    a.nombre_comercial > b.nombre_comercial ? 1 : -1
                  )
                  .map((c) => (
                    <option key={c._id} value={c._id}>
                      {c.nombre_comercial}
                    </option>
                  ))}
              </Input>
            </Col>
            <Col md={5}>
              <Search onSearch={(v) => { setSearch(v); setCurrentPage(1); }} />
            </Col>
          </Row>

          {/* Tarjetas de resumen */}
          <Row className="mb-3" align="center">
            <Col md={2}>
              <Label className="mr-sm-2">Notas</Label>
              <h5>
                <Badge color="dark" className="BadgeSize badge-pill">
                  {paraExportar.length}
                </Badge>
              </h5>
            </Col>
            <Col md={2}>
              <Label className="mr-sm-2">Venta</Label>
              <h5>
                <Badge color="info" className="BadgeSize badge-pill">
                  {money(ventaFiltrada)}
                </Badge>
              </h5>
            </Col>
            <Col md={2}>
              <Label className="mr-sm-2">Costo</Label>
              <h5>
                <Badge color="secondary" className="BadgeSize badge-pill">
                  {money(sumaDe("costo"))}
                </Badge>
              </h5>
            </Col>
            <Col md={2}>
              <Label className="mr-sm-2">Comisiones + Gastos</Label>
              <h5>
                <Badge color="warning" className="BadgeSize badge-pill">
                  {money(sumaDe("comision") + sumaDe("comisionEstimada") + sumaDe("gastoDirecto") + sumaDe("gastoGeneral"))}
                </Badge>
              </h5>
            </Col>
            <Col md={2}>
              <Label className="mr-sm-2">Utilidad</Label>
              <h5>
                <Badge
                  color={utilidadFiltrada >= 0 ? "success" : "danger"}
                  className="BadgeSize badge-pill"
                >
                  {money(utilidadFiltrada)}
                </Badge>
              </h5>
            </Col>
            <Col md={2}>
              <Label className="mr-sm-2">Margen</Label>
              <h5>
                <Badge
                  color={Number(margenFiltrado) >= 0 ? "success" : "danger"}
                  className="BadgeSize badge-pill"
                >
                  {margenFiltrado}%
                </Badge>
              </h5>
            </Col>
          </Row>

          {/* Qué contiene cada columna. Sin esto no se entiende de dónde sale
              cada resta, sobre todo el gasto general, que es prorrateado. */}
          <div className="mb-3">
            <Button
              size="sm"
              color="link"
              style={{ paddingLeft: 0 }}
              onClick={() => setVerAyuda(!verAyuda)}
            >
              {verAyuda ? "Ocultar" : "¿Qué va en cada columna?"}
            </Button>
            {verAyuda ? (
              <Table size="sm" bordered className="table-responsive-xl mt-1">
                <thead>
                  <tr align="center">
                    <th className="tituloTabla">Columna</th>
                    <th className="tituloTabla">Qué contiene</th>
                    <th className="tituloTabla">De dónde sale</th>
                  </tr>
                </thead>
                <tbody style={{ fontSize: 13 }}>
                  <tr>
                    <td className="negrita">Venta</td>
                    <td>Total de la nota, con IVA y ya con el descuento aplicado.</td>
                    <td>Nota de venta</td>
                  </tr>
                  <tr>
                    <td className="negrita">Costo</td>
                    <td>
                      Suma del costo de cada renglón surtido, sellado al momento
                      de surtir.
                    </td>
                    <td>Renglones de la nota</td>
                  </tr>
                  <tr>
                    <td className="negrita">Comisión</td>
                    <td>
                      Gasto <b>directo</b> de la venta: la comisión <b>ya pagada</b>,
                      incluido su ajuste (bono o descuento con concepto) y los{" "}
                      <b>viáticos</b> de ese pago. Si una comisión cubre varias
                      notas, se reparte entre ellas en proporción a su venta.
                    </td>
                    <td>Comisiones pagadas</td>
                  </tr>
                  <tr>
                    <td className="negrita">Comisión est.</td>
                    <td>
                      Para notas que <b>aún no</b> tienen comisión pagada: lo que
                      le tocaría al vendedor según su % (pactado en cotización,
                      especial del cliente, o general). Se pinta en ámbar para
                      distinguirla de la real. Cuando se paga, pasa a la columna
                      Comisión.
                    </td>
                    <td>Ficha del vendedor</td>
                  </tr>
                  <tr>
                    <td className="negrita">Gasto Directo</td>
                    <td>
                      Gastos cargados a esa nota en particular (fletes,
                      maniobras, lo que se capture en la venta).
                    </td>
                    <td>Ventas → Gastos de la nota</td>
                  </tr>
                  <tr>
                    <td className="negrita">Gasto General</td>
                    <td>
                      Gastos del periodo que no pertenecen a ninguna nota —los
                      capturados en Gastos y algún viático suelto que no esté
                      ligado a ventas—,{" "}
                      <b>repartidos entre todas</b> en proporción a su venta. Al
                      filtrar por cliente, a ese cliente sólo le toca su parte, no
                      el gasto de toda la empresa.
                    </td>
                    <td>Gastos → Gastos</td>
                  </tr>
                  <tr style={{ backgroundColor: "#eef7f1" }}>
                    <td className="negrita">Utilidad</td>
                    <td colSpan={2}>
                      <b>
                        Venta − Costo − Comisión − Comisión est. − Gasto Directo − Gasto General
                      </b>
                      . El margen es la utilidad sobre la venta de esa misma nota.
                    </td>
                  </tr>
                </tbody>
              </Table>
            ) : null}
          </div>

          {infoGastos && Number(infoGastos.total) === 0 ? (
            <p className="text-muted" style={{ fontSize: 13 }}>
              No hay gastos generales en este periodo, así que esa columna sale
              en cero. Se toman de Gastos → Gastos y se reparten entre las notas
              del rango en proporción a su venta.
            </p>
          ) : infoGastos ? (
            <p className="text-muted" style={{ fontSize: 13 }}>
              Gasto general del periodo: {money(infoGastos.total)}
              {Number(infoGastos.viaticos) > 0 ? (
                <>
                  {" "}= {money(infoGastos.capturados)} de gastos capturados +{" "}
                  {money(infoGastos.viaticos)} de viáticos sin ventas ligadas
                </>
              ) : null}
              , repartido entre las notas por su venta. Los viáticos de cada pago
              de comisión van en la columna Comisión.
            </p>
          ) : null}

          <div className="col-md-6">
            <Pagination
              total={totalItems}
              itemsPerPage={ITEMS_PER_PAGE}
              currentPage={currentPage}
              onPageChange={(page) => setCurrentPage(page)}
            />
          </div>

          <Table size="sm" striped bordered className="table-responsive-xl">
            <TableHeader
              headers={headers}
              onSorting={(field, order) => setSorting({ field, order })}
            />
            <tbody>
              {cargando ? (
                <tr>
                  <td colSpan={12}>Cargando…</td>
                </tr>
              ) : filtrado.length === 0 ? (
                <tr>
                  <td colSpan={12}>Sin ventas en este periodo.</td>
                </tr>
              ) : (
                filtrado.map((r) => (
                  <tr
                    key={r._id}
                    style={r.utilidad < 0 ? { backgroundColor: "#ed8c8c" } : undefined}
                  >
                    <td>{r.idSurtido}</td>
                    <td>{fDMA(r.fecha)}</td>
                    <td>{r.cliente}</td>
                    <td>{r.factura}</td>
                    <td align="right">{money(r.venta)}</td>
                    <td align="right">{money(r.costo)}</td>
                    <td align="right" title={r.viaticosComision > 0 ? `Incluye ${money(r.viaticosComision)} de viáticos` : undefined}>
                      {money(r.comision)}
                      {r.viaticosComision > 0 ? (
                        <div style={{ fontSize: 11, color: "#666" }}>incl. viát. {money(r.viaticosComision)}</div>
                      ) : null}
                    </td>
                    <td align="right" style={{ color: r.comisionEstimada > 0 ? "#b8860b" : undefined }}
                        title={r.comisionEstimada > 0 ? "Estimada: esta nota aún no tiene comisión pagada" : undefined}>
                      {money(r.comisionEstimada)}
                    </td>
                    <td align="right">{money(r.gastoDirecto)}</td>
                    <td align="right">{money(r.gastoGeneral)}</td>
                    <td align="right" className="negrita">
                      {money(r.utilidad)}
                    </td>
                    <td align="right">{r.margen}%</td>
                  </tr>
                ))
              )}
              <tr>
                <td colSpan={4} className="negrita" align="right">
                  TOTALES
                </td>
                <td className="negrita" align="right">{money(ventaFiltrada)}</td>
                <td className="negrita" align="right">{money(sumaDe("costo"))}</td>
                <td className="negrita" align="right">{money(sumaDe("comision"))}</td>
                <td className="negrita" align="right" style={{ color: "#b8860b" }}>{money(sumaDe("comisionEstimada"))}</td>
                <td className="negrita" align="right">{money(sumaDe("gastoDirecto"))}</td>
                <td className="negrita" align="right">{money(sumaDe("gastoGeneral"))}</td>
                <td className="negrita" align="right">{money(utilidadFiltrada)}</td>
                <td className="negrita" align="right">{margenFiltrado}%</td>
              </tr>
            </tbody>
          </Table>

          <div className="col-md-6">
            <Pagination
              total={totalItems}
              itemsPerPage={ITEMS_PER_PAGE}
              currentPage={currentPage}
              onPageChange={(page) => setCurrentPage(page)}
            />
          </div>
        </div>
      ) : undefined}
      {loader}
    </>
  );
}

export default ReporteUtilidades;
